import { Stack, Typography, Box } from "@mui/material"
import { useEffect, useState } from "react"
import { Labeled, Link, NumberField, useRecordContext } from "react-admin"
import { InvoicesApiGetTotalInvoiceAmountsRequest, TotalInvoiceAmounts } from "../GeneratedClients/FreeBillApi"
import fetchTotalAmounts from "../invoices/list/fetchTotalAmounts"

const CustomerStatistic = () => {

  const record = useRecordContext()
  const [totalAmounts, setTotalAmounts] = useState<TotalInvoiceAmounts>()

  const fetchData = async() => {
    const resource = "invoices"
    const params: InvoicesApiGetTotalInvoiceAmountsRequest = {
      invoiceRecipientIdEq: record.id.toString(),
      isCanceledEq: false
    }
    const totalAmounts = await fetchTotalAmounts(resource, params)
    setTotalAmounts(totalAmounts)
  }

  useEffect(() => {
    fetchData()
  }, [])

  if(!record) return null

  return (
    <Stack spacing={1}>
        <Labeled>
          <NumberField record={totalAmounts} source="totalNetAmount" label="resources.customers.statistic.salesNet" emptyText="-" options={{ style: 'currency', currency: 'EUR' }} />
        </Labeled>  
        <Labeled>
          <NumberField record={totalAmounts} source="totalTaxAmount" label="resources.customers.statistic.salesTax" emptyText="-" options={{ style: 'currency', currency: 'EUR' }} />
        </Labeled>  
        <Labeled>
          <NumberField record={totalAmounts} source="totalGrossAmount" label="resources.customers.statistic.salesGross" emptyText="-" options={{ style: 'currency', currency: 'EUR' }} />
        </Labeled>  
        <Box pt={2}>
          <Link 
            to={{
              pathname: '/invoices', 
              search:`filter=${JSON.stringify(
                { companyName_Contains: record.company.companyName }
              )}`
            }}
          >
            {<Typography variant="body2">{`Rechnungsliste für ${record.company.companyName} anzeigen`}</Typography>}
          </Link>
        </Box>
        
    </Stack>
  )
}

export default CustomerStatistic